module.exports = __webpack_public_path__ + "img/protective_gear7.519df8df.png";